export default __webpack_public_path__ + "media/zurb/img/home/home-process-img3-99267b04b5728ce4b0ec4a8ae00a0f72.png";